import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyLocal'
})
export class CurrencyLocalPipe implements PipeTransform {

  constructor(private currencyPipe: CurrencyPipe) { }

  transform(value: number): string {

    return "$" + this.currencyPipe.transform(value, undefined, '')
  }
}
